import { createContext, useContext } from 'react';
export var PageConfigContext = /*#__PURE__*/createContext(null);
export var PageConfigProvider = PageConfigContext.Provider;
export var usePageConfig = function usePageConfig() {
  var pageConfig = useContext(PageConfigContext);

  if (!pageConfig) {
    throw new Error("Page config isn't available. Please set it via PageConfigContext component.");
  }

  return pageConfig;
};